module.exports = __webpack_public_path__ + "img/Tick-Circle.252919b2.svg";